import {Component, Input, OnInit, HostListener} from '@angular/core';

@Component({
  selector: 'lps-card-grid',
  templateUrl: './card-grid.component.html',
  styleUrls: ['./card-grid.component.scss']
})
export class CardGridComponent implements OnInit {

  @Input() showSwiper = false;
  @Input() loading: boolean;
  @Input() target = '_top';
  @Input() numberSkeletons = 24;
  @Input() productBaseLink: string;
  @Input() hideBookmark?: boolean;
  @Input() set productCards(productCards: any[]) {
    this.internalProductCards = productCards;
    this.sizeCards = this.validateGrid();
  }

  get productCards(): any[] {
    return this.internalProductCards;
  }

  @Input() theme: 'home' | 'similar' | 'search' | 'campaign' | 'broker' = 'home';
  @Input() displayRealtorContactLink: boolean;

  @Input() gridName: string;
  @Input() showGrid3Cols: boolean;
  @Input() nickname: string;

  internalProductCards: any[] = [];
  sizeCards = 4;

  previousTheme: 'home' | 'similar' | 'search' | 'campaign' | 'broker';

  skeletons: Array<number>;

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.alterThemeSimilar(event.target.innerWidth);
  }

  ngOnInit() {
    this.skeletons = [...Array(this.numberSkeletons)].map((v, i) => i);
    this.sizeCards = this.validateGrid();
    this.previousTheme = this.theme;
    this.alterThemeSimilar(window.innerWidth);
  }

  alterThemeSimilar(size: number) {
    if (this.theme === 'similar' && size <= 768) {
      this.theme = 'home';
    } else if (size > 768) {
      this.theme = this.previousTheme;
    }
  }

  validateGrid() {
    let sizeCards = this.productCards.length || 4;
    if (this.theme === 'home' && sizeCards >= 4) {
      sizeCards = 4;
    }
    return sizeCards;
  }
}
